import RedeemGift from "components/Auth/RedeemGift"
import Verification from "components/Auth/VerificationOTP"
import VerificationNew from "components/Auth/verification-new"
import { pathApp } from "services/utiles"

// const pathApp = '/app'


const PrivateRoutes = [
  { path: `/verification`, name: 'verification', component: Verification },
  { path: `/redeem-gift`, name: 'redeem-gif', component: RedeemGift },

  { path: `/forgot-verification`, name: 'forgot-verification', component: VerificationNew },

]
export default PrivateRoutes
